module.exports = __webpack_public_path__ + "img/lazada_1.09ae185a.png";